var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h200v200H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(.00862 0 0 .00862 -.138 -.138)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 148,
    height: 148,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAACUCAIAAAD6XpeDAAAAA3NCSVQICAjb4U/gAAADNklEQVR4nO2dy24kIQwAd1b5/1+eXLlYwrFNU+qqYwQ0mpJj8f58v99/wuT/0x2Qv6M8MMoDozwwygOjPDDKA6M8MMoDozwwygOjPDDKA6M8MMoD85Ot8Pl82jsxvaYY9Tn67k75G34HIw+M8sAoD0w6561UclUlZ6x1d/qwUybbZrb9ne9mMfLAKA+M8sCUct7Kzv/urtwTjbcqf++i63fYwcgDozwwygPTlvOmyY6HKvk1Oxf6FEYeGOWBUR6Yq3Ne1zpcV93bMPLAKA+M8sC05byJMdBOfsp+N6rblQtPjgWNPDDKA6M8MKWcd3Js1LVuF/W5K4+exMgDozwwygOTznk3rGll81Z2X8wON/wORh4Y5YFRHphP19xgZazTdU4uuw/lqbGd+zZFeWSUB2ZkPW/6PED03Z3+ZPuW3RdTad8z6S9CeWCUByY9zgsbalpXW6mM/3aotHPyHF6EkQdGeWCUB6Yt55U60ZT/Tp5Vr+zn7BoHG3lglAdGeWBK63kr2f/pXTkjKhMxvc6X/VYFIw+M8sAoD0zbHpZK+UqZ6ftZdtrpysGu570I5YFRHhjMvs3p+cYKT33XyAOjPDDKA3P07rGuPSkTeym73g+aHtutGHlglAdGeWCOrudV8krXnOf0vGjUt0o7EUYeGOWBUR6YkbMKESfvz8z2bYLpt42MPDDKA6M8MI/dt7lTt2uc1LV3Jtv+Ds5tvhTlgVEemNI4b3qdbPpOson1RdfzZAvlgVEemPGcF5WPmL57JdufChP7X1aMPDDKA6M8MFfcw7Iysfckaifbn4nzEivmvBehPDDKA5Nez5sYG0Vvt07nv666T71DZOSBUR4Y5YEp7WGZmFfM5pKuMxI7fdupmy3jvs2XojwwygPTdiZ9Yr0qm6sm3nOI3iHKMvG+kpEHRnlglAfm6D0sE1TyYpaJd2Xdt/lSlAdGeWCuznmVd19veLc9wrMKojwyygMz8k76dDuVMjtznk+9hZTFyAOjPDDKA9N232aFrru4Tvatq80KRh4Y5YFRHpjrzufJPkYeGOWBUR4Y5YFRHhjlgVEeGOWBUR4Y5YFRHhjlgVEeGOWBUR6YXxElIBO+v0s4AAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr1);
export default __webpack_public_path__ + "static/media/qr-1.5ec98d31120531d38f2f9cd93b129e9f.svg";
export { ForwardRef as ReactComponent };